export const maxMobileWidth = 578;

/**
 * Format value as a string including fractional codes
 */
export function fraction(value: number): string {
    if (!value && value !== 0) return '';

    let text = Math.floor(value).toString();
    const decimal = ((value * 100) % 100) / 100;

    if (value % 1 !== 0) {
        text = Math.floor(value).toString();
        //don't display fraction leading with 0, just display the fraction
        if (text === '0') text = '';
        // append unicode fraction characters rather than html escape codes
        // so they will appear unescaped as tag contents
        if (decimal === 0.25) text += '\xbc';
        if (decimal === 0.5) text += '\xbd';
        if (decimal === 0.75) text += '\xbe';
    }
    return text;
}

/**
 * Google geocoder doesn't recognize apartment numbers if there's a space after
 * the pound character even though that's the format sometimes returned by their
 * own autocomplete
 */
export const normalizeAddress = (a: string): string => a.replace(/#\s+([^\s]+)/, '#$1');

/**
 * Localized currency value
 */
export function currency(value: number, locale: string, code: string): string {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
    });

    return formatter.format(value).replace('.00', '');
}

/**
 * Validates that a phone number is in E164 format
 * https://www.twilio.com/docs/glossary/what-e164#:~:text=Billy%20Chia-,E.,individual%20phones%20in%20different%20countries
 */
export function validatePhoneE164(phoneNumber: string) {
    const regEx = /^\+[1-9]\d{7,14}$/;
    let validatedNumber = '';
    validatedNumber = removeExtraCharactersFromNumber(phoneNumber);

    if (!validatedNumber.startsWith('+')) {
        validatedNumber = prependCountryCodeToPhoneNumber(validatedNumber);
    }

    if (regEx.test(validatedNumber)) {
        return validatedNumber;
    } else {
        return 'Phone number is not valid format';
    }
}

// removes non numeric characters from phone number besides the '+'
export function removeExtraCharactersFromNumber(phoneNumber: string) {
    const regEx = /[^0-9+]/g;
    return phoneNumber.replace(regEx, '');
}

// prepends +[ US country code] to phone number
export function prependCountryCodeToPhoneNumber(phoneNumber: string) {
    const usCountryCode = '1';

    if (phoneNumber.startsWith('+')) {
        return phoneNumber;
    }

    if (phoneNumber.length < 7) {
        return phoneNumber;
    }

    if (phoneNumber.length === 10 && phoneNumber.startsWith(usCountryCode)) {
        return `+${usCountryCode}${phoneNumber}`;
    }

    if (phoneNumber.length === 11 && phoneNumber.startsWith(usCountryCode)) {
        return `+${phoneNumber}`;
    }

    return `+${usCountryCode}${phoneNumber}`;
}

export function roundToHundred(value: number) {
    return Math.round(value / 100) * 100;
}
